"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkForcefullyDisabled = checkForcefullyDisabled;
const cookieName = 'disableAppAnalytics';
// In some cases we want to forcefully disable analytics for some users,
// e.g. canary bots, or users who have opted out of analytics.
function checkForcefullyDisabled() {
    if (typeof window === 'undefined') {
        return true;
    }
    return Boolean(document.cookie
        .split(';')
        .map((c) => c.trim())
        .find((c) => c.startsWith(`${cookieName}=`)));
}
//# sourceMappingURL=checkForcefullyDisabled.js.map